'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  SERVER_ERROR: null,
  CONNECTION_ERROR: null,

  SHARE_POSTED_STAMP: null,
  DELETE_DRAFT: null,
  DELETE_STAMP: null,
  DELETE_ZINE: null,

  EDITOR_DESKTOP_ONLY: null,
  EDITOR_COVER_TITLE_REQUIRED: null,
  EDITOR_TITLE_REQUIRED: null,
  EDITOR_COVER_REQUIRED: null,
  EDITOR_DELETE_SECTION: null,
  EDITOR_ADD_MORE_CONTENT: null,
  EDITOR_DISREGARD_CHANGES: null,
  UPLOAD_USER_IMAGE_ERROR: null,
  LOGOUT: null,
  NOT_FOUND: null,

  AUDIO_NOT_FOUND: null,
  VIDEO_NOT_FOUND: null,
  VIDEO_EMBED_FORBIDDEN: null,

  ZINE_TITLE_TOO_SHORT: null,
  ZINE_TITLE_TWO_WORDS: null,
  ZINE_DESCRIPTION_TOO_SHORT: null,
  ZINE_ALREADY_EXISTS: null,

  STAMP_SAVE_IMAGE_HELP: null,
  SHARE_DRAFT: null
});


/** WEBPACK FOOTER **
 ** ./constants/AlertTypes.js
 **/